<template>
  <v-app id="keep">
    <v-app-bar app clipped-left color="primary" dark>

      <span class="hidden-sm-and-down">{{this.$store.state.msg.app.institution}}</span>
      <span class="hidden-md-and-up">MJTI</span>
      <v-spacer />
      <v-btn text small class="hidden-sm-and-down">{{user.nombreUsuario}}</v-btn>
      <v-menu bottom offset-y left min-width="200px">
        <template v-slot:activator="{on}">
          <v-btn icon v-on="on">
            <v-avatar size="40" color="white">
              <img :src="obtnerFoto()" />
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop="dialog=true">
            <v-list-item-avatar>
              <v-icon>vpn_key</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Cambiar Contraseña</v-list-item-title>
          </v-list-item>
          <v-list-item @click="signout">
            <v-list-item-avatar>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Cerrar Sesion</v-list-item-title>
          </v-list-item>
        </v-list>
        <Contrasenia :dialog="dialog" @cancelar="dialog=false" @confirmado="dialog=false" />
      </v-menu>
    </v-app-bar>
    <v-snackbar v-model="error" multi-line right top color="error">{{ error }}</v-snackbar>
    <v-content class="app_central">
      <v-container>
        <v-layout row justify-center align-center>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer dark padless>
      <v-card class="flex" flat tile>
        <v-card-text class="grey darken-3 text-center caption py-2">
          <strong>{{ this.$store.state.msg.app.made }} -  {{ new Date().getFullYear() }} </strong>
        </v-card-text>
      </v-card>
    </v-footer>
     <v-overlay :value="loading_app">
      <v-progress-circular indeterminate size="64" class="mb-5"></v-progress-circular> <br/>{{mensaje_app}}
    </v-overlay>
  </v-app>
</template>

<script>
import Auth from '@/components/mixins/auth'
import { mapState } from 'vuex'
export default {
  name: 'TemplateBase',
  mixins: [Auth],
  data () {
    return {
      tile: true,
      dialog: false,
      snackbar: false
    }
  },
  components: {
    Contrasenia: () => import('@/components/Contrasenia')
  },
  computed: {
    ...mapState(['user', 'mensaje_app', 'loading_app']),
    error () {
      return this.$store.state.error
    },
    loading () {
      return this.$store.state.loading
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.snackbar = true
      }
    },
    snackbar (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  },
  methods: {
    signout () {
      this.cerrarSesion()
    },
    obtnerFoto () {
      return this.$docUrl + this.user.urlFotoPerfil
    }
  }
}
</script>

<style>
.app_desing {
  width: "100px";
  height: "100px";
}
.app_central {
  background-image: url(../assets/background.png) !important;
  background-repeat: repeat;
  background-size: 40% !important;
}
</style>
